import { type APIResponse, type MatterRole } from "@/lib/types";
import { authenticatedFastApiAxiosInstance } from "../../http";
import { baseFastApiMatterRoute } from "./matter";

export const createMatterRoleV1 = (data: Partial<MatterRole>) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<MatterRole>>(`${baseFastApiMatterRoute}/roles`, data)
    .then((res) => res.data);
};

export const updateMatterRoleV1 = (
  data: Pick<MatterRole, "id" | "dateModified"> &
    Partial<MatterRole> & { matterRoleId?: string },
) => {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<MatterRole>>(`${baseFastApiMatterRoute}/roles`, data)
    .then((res) => res.data);
};

export const deleteMatterRoleV1 = (data: { id: string }) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<MatterRole>>(`${baseFastApiMatterRoute}/roles/${id}`)
    .then((res) => res.data);
};
